import { Component, forwardRef, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ConfigurationParameter } from '../../model';
import { RecipeParameterSelectorComponent } from "./recipe-parameter-selector.component";

@Component({
    selector: 'recipe-parameters-management-dialog',
    template: require('./recipe-parameters-management-dialog.component.html')
})
export class RecipeParametersManagementDialogComponent {

    @ViewChild(RecipeParameterSelectorComponent) parameterSelector: RecipeParameterSelectorComponent;

    allParameters: ConfigurationParameter[];
    selectedParameters: ConfigurationParameter[];

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<RecipeParametersManagementDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
    ) {
        this.allParameters = data.allParameters;
        this.selectedParameters = data.selectedParameters;
    }

    save(): void {
        this.dialogRef.close(this.parameterSelector.getSelected());
    }

}
